import React from 'react';
import ReactDom from 'react-dom';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import AssessmentIcon from '@material-ui/icons/Assessment';
import NumberFormat from 'react-number-format';
import Moment from 'react-moment';
import 'moment-timezone';
import Select2 from 'react-select';
import 'tails-ui/dist/index.css';
import Chart from 'react-google-charts';
import BarChartIcon from '@material-ui/icons/BarChart';
import TimelineIcon from '@material-ui/icons/Timeline';
import ReactHtmlParser from 'react-html-parser';
import CsvDownloader from 'react-csv-downloader';
import Reports from '../components/Reports';
import SearchReports from '../components/SearchReports';
import Documents from '../components/Documents';
import Tags from '../components/Tags';
import BillingStatements from '../components/BillingStatements.js';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Picker from 'react-month-picker';
import 'react-month-picker/css/month-picker.css';
import Select from 'react-select';
import {Link} from 'react-router-dom';

const useStyles = makeStyles(theme => ({
    icon: {
        marginRight: theme.spacing(2),
    },
    heroContent: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(8, 0, 6),
    },
    heroButtons: {
        marginTop: theme.spacing(4),
    },
    cardGrid: {
        paddingTop: theme.spacing(8),
        paddingBottom: theme.spacing(8),
    },
    card: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    cardMedia: {
        paddingTop: '56.25%', // 16:9
    },
    cardContent: {
        flexGrow: 1,
    },
    footer: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(6),
    },
    paperLeft: {
        width: '25%',
        float: 'left',
        padding: '25px',
        marginRight: '25px',
    },
    paperRight: {
        width: '65%',
        float: 'left',
        padding: '25px',
    },
}));
const arrowdown = (
    <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        className="feather feather-arrow-up-circle"
    >
        <circle cx="12" cy="12" r="10" />
        <polyline points="16 12 12 8 8 12" />
        <line x1="12" y1="16" x2="12" y2="8" />
    </svg>
);
const daterangeOptions = [
    {value: 'Custom', label: 'Custom'},
    // { value: 'Today', label: 'Today' },
    {value: 'Yesterday', label: 'Yesterday'},
    {value: 'Last 7 days', label: 'Last 7 days'},
    {value: 'Last 30 days', label: 'Last 30 days'},
    {value: 'Last 60 days', label: 'Last 60 days'},
    {value: 'Last 90 days', label: 'Last 90 days'},
    {value: 'This week', label: 'This week'},
    {value: 'Last week', label: 'Last week'},
    {value: 'This Month', label: 'This Month'},
    {value: 'Last Month', label: 'Last Month'},
];

export default function DashboardViews(props) {
    const classes = useStyles();
    const [selectedOption, setOption] = React.useState('');
    const [selectedSource, selectSource] = React.useState('');
    //const [partnerRevenue_2, setpartnerRevenue_2] = React.useState(null);
    //const [acceptLeads_2, setacceptLeads_2] = React.useState(null);
    const [Filter_oneSelectedOption, setFilter_oneSelectedOption] = React.useState({
        value: 8,
        label: 'Accepted Leads',
    });
    const [Filter_secondSelectedOption, setFilter_secondSelectedOption] = React.useState({
        value: 1,
        label: 'Your Revenue ($)',
    });
    const [BarChartType, setBarChartType] = React.useState(
        'shadow border bg-orange text-white border-black rounded ml-1 mt-3 mb-2 text-xs'
    );
    const [LineChartType, setLineChartType] = React.useState(
        'chartType shadow border border-black rounded ml-1 mt-3 mb-2 text-xs'
    );

    const [lineChartClass, setlineChartClass] = React.useState(
        'w-full sm:w-1/1 w-4/5  mr-3 mb-3 p-3 float-left text-center hidden'
    );
    const [barChartClass, setbarChartClass] = React.useState(
        'w-full sm:w-1/1 w-4/5  mr-3 mb-3 p-3 float-left text-center'
    );

    const [value, setValue] = React.useState(0);
    // const [tabactive, setTabActive] = React.useState("");

    const TabhandleChange = (event, newValue) => {
        setValue(newValue);
        localStorage.setItem('value', newValue);

        if (newValue === 0) {
            props.dashboardRequest();
        }
    };

    React.useEffect(() => {
        const tabactive = Number(localStorage.getItem('value') || 0);
        setValue(tabactive);
    }, [value]);

    const get_token = localStorage.getItem('token');
    const userId = localStorage.getItem('userId');
    const inpersonateFlag = localStorage.getItem('inpersonate');

    let chartdata = props.chartData;
    let dataLoad = props.chartLoad;
    const options = [];
    const uniqueDomains = [];
    const uniqueSource = [];
    const uniqueSourceOptions = [];
    const defaultData = props.defaultData;

    let columns = [];
    columns = [
        {id: 'first', displayName: 'Months'},
        {id: 'second', displayName: 'Your Revenue'},
        {id: 'third', displayName: 'Visits'},
        {id: 'fourth', displayName: 'Unique Inquirers'},
        {id: 'fifth', displayName: 'Unique Inquries'},
        {id: 'six', displayName: 'Unique Students'},
        {id: 'seven', displayName: 'Failed Filters'},
        {id: 'eight', displayName: 'Rejected Leads'},
        {id: 'nine', displayName: 'Acepted Leads'},
        {id: 'ten', displayName: 'Unique Visitors'},
        {id: 'eleven', displayName: 'Unique Conversion Rate (%)'},
        {id: 'twelve', displayName: 'Revenue per Student ($)'},
        {id: 'thirteen', displayName: 'Filter Pass Rate (%)'},
        {id: 'fourteen', displayName: 'Rejection Rate (%)'},
        {id: 'fifteen', displayName: 'Leads per Student'},
        {id: 'sixteen', displayName: 'Revenue per Accepted Lead ($)'},
    ];

    undefined !== chartdata &&
        0 < chartdata.length &&
        chartdata.map(data => {
            if (uniqueDomains.indexOf(data.domain) === -1) {
                uniqueDomains.push(data.domain);
            }
            if (uniqueSource.indexOf(data.source) === -1) {
                uniqueSource.push(data.source);
            }
        });

    const chartDomains = uniqueDomains.map(data => options.push({value: data, label: data}));

    uniqueSource.map(data => uniqueSourceOptions.push({value: data, label: data}));

    function a11yProps(index) {
        return {
            id: `scrollable-auto-tab-${index}`,
            'aria-controls': `scrollable-auto-tabpanel-${index}`,
        };
    }

    function TabPanel(props) {
        const {children, value, index, ...other} = props;

        return (
            <Typography
                component="div"
                role="tabpanel"
                hidden={value !== index}
                id={`scrollable-auto-tabpanel-${index}`}
                aria-labelledby={`scrollable-auto-tab-${index}`}
                {...other}
            >
                <Box p={3}>{children}</Box>
            </Typography>
        );
    }

    TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.any.isRequired,
        value: PropTypes.any.isRequired,
    };

    const months = {};
    let num_acceptedLeads = 0;
    let Revenue = 0;
    let failedFilters = 0;
    let FilterPassRates = 0;
    let LeadsperStudent = 0;
    let RejectedLeads = 0;
    let RejectionRate = 0;
    let RevenueperAcceptedLead = 0;
    let RevenueperStudent = 0;
    let UniqueConversionRate = 0;
    let UniqueInquirers = 0;
    let UniqueInquries = 0;
    let UniqueStudents = 0;
    let UniqueVisitors = 0;
    let Visits = 0;
    let month = '';
    let chartXLabel = 'Hours';
    const domainsList = [];
    let csvDatas = [];
    const chartRData =
        //chartdata &&
        undefined !== chartdata &&
        0 < chartdata.length &&
        chartdata.map(rData => {
            month = rData.dateTimeAgg;

            if (rData.dateTimeAgg in months) {
                if (
                    selectedOption &&
                    Object.keys(selectedOption).length > 0 &&
                    selectedSource &&
                    Object.keys(selectedSource).length > 0
                ) {
                    Object.keys(selectedOption).forEach(function (key) {
                        Object.keys(selectedSource).forEach(function (skey) {
                            if (
                                selectedOption[key].value == rData.domain &&
                                selectedSource[skey].value == rData.source
                            ) {
                                num_acceptedLeads = num_acceptedLeads + rData.acceptedLeads;
                                Revenue = Revenue + rData.partnerRevenue;
                                failedFilters = failedFilters + rData.failedFilters;
                                RejectedLeads = RejectedLeads + rData.rejectedLeads;
                                UniqueInquirers = UniqueInquirers + rData.uniqueInquirers;
                                UniqueInquries = UniqueInquries + rData.uniqueInquries;
                                UniqueStudents = UniqueStudents + rData.uniqueStudents;
                                UniqueVisitors = UniqueVisitors + rData.uniqueVisitors;
                                Visits = Visits + rData.visits;
                            }
                        });
                    });
                } else if (selectedOption && Object.keys(selectedOption).length > 0) {
                    Object.keys(selectedOption).forEach(function (key) {
                        if (selectedOption[key].value == rData.domain) {
                            num_acceptedLeads = num_acceptedLeads + rData.acceptedLeads;
                            Revenue = Revenue + rData.partnerRevenue;
                            failedFilters = failedFilters + rData.failedFilters;
                            RejectedLeads = RejectedLeads + rData.rejectedLeads;
                            UniqueInquirers = UniqueInquirers + rData.uniqueInquirers;
                            UniqueInquries = UniqueInquries + rData.uniqueInquries;
                            UniqueStudents = UniqueStudents + rData.uniqueStudents;
                            UniqueVisitors = UniqueVisitors + rData.uniqueVisitors;
                            Visits = Visits + rData.visits;
                        }
                    });
                } else if (selectedSource && Object.keys(selectedSource).length > 0) {
                    Object.keys(selectedSource).forEach(function (key) {
                        if (selectedSource[key].value == rData.source) {
                            num_acceptedLeads = num_acceptedLeads + rData.acceptedLeads;
                            Revenue = Revenue + rData.partnerRevenue;
                            failedFilters = failedFilters + rData.failedFilters;
                            RejectedLeads = RejectedLeads + rData.rejectedLeads;
                            UniqueInquirers = UniqueInquirers + rData.uniqueInquirers;
                            UniqueInquries = UniqueInquries + rData.uniqueInquries;
                            UniqueStudents = UniqueStudents + rData.uniqueStudents;
                            UniqueVisitors = UniqueVisitors + rData.uniqueVisitors;
                            Visits = Visits + rData.visits;
                        }
                    });
                } else {
                    num_acceptedLeads = num_acceptedLeads + rData.acceptedLeads;
                    Revenue = Revenue + rData.partnerRevenue;
                    failedFilters = failedFilters + rData.failedFilters;
                    RejectedLeads = RejectedLeads + rData.rejectedLeads;
                    UniqueInquirers = UniqueInquirers + rData.uniqueInquirers;
                    UniqueInquries = UniqueInquries + rData.uniqueInquries;
                    UniqueStudents = UniqueStudents + rData.uniqueStudents;
                    UniqueVisitors = UniqueVisitors + rData.uniqueVisitors;
                    Visits = Visits + rData.visits;
                }
            } else {
                if (
                    selectedOption &&
                    Object.keys(selectedOption).length > 0 &&
                    selectedSource &&
                    Object.keys(selectedSource).length > 0
                ) {
                    num_acceptedLeads = 0;
                    Revenue = 0;
                    failedFilters = 0;
                    RejectedLeads = 0;
                    UniqueInquirers = 0;
                    UniqueInquries = 0;
                    UniqueStudents = 0;
                    UniqueVisitors = 0;
                    Visits = 0;

                    Object.keys(selectedOption).forEach(function (key) {
                        Object.keys(selectedSource).forEach(function (skey) {
                            if (
                                selectedOption[key].value == rData.domain &&
                                selectedSource[skey].value == rData.source
                            ) {
                                num_acceptedLeads = rData.acceptedLeads;
                                Revenue = rData.partnerRevenue;
                                failedFilters = rData.failedFilters;
                                RejectedLeads = rData.rejectedLeads;
                                UniqueInquirers = rData.uniqueInquirers;
                                UniqueInquries = rData.uniqueInquries;
                                UniqueStudents = rData.uniqueStudents;
                                UniqueVisitors = rData.uniqueVisitors;
                                Visits = rData.visits;
                            }
                        });
                    });
                } else if (selectedOption && Object.keys(selectedOption).length > 0) {
                    num_acceptedLeads = 0;
                    Revenue = 0;
                    failedFilters = 0;
                    RejectedLeads = 0;
                    UniqueInquirers = 0;
                    UniqueInquries = 0;
                    UniqueStudents = 0;
                    UniqueVisitors = 0;
                    Visits = 0;

                    Object.keys(selectedOption).forEach(function (key) {
                        if (selectedOption[key].value == rData.domain) {
                            num_acceptedLeads = rData.acceptedLeads;
                            Revenue = rData.partnerRevenue;
                            failedFilters = rData.failedFilters;
                            RejectedLeads = rData.rejectedLeads;
                            UniqueInquirers = rData.uniqueInquirers;
                            UniqueInquries = rData.uniqueInquries;
                            UniqueStudents = rData.uniqueStudents;
                            UniqueVisitors = rData.uniqueVisitors;
                            Visits = rData.visits;
                        }
                    });
                } else if (selectedSource && Object.keys(selectedSource).length > 0) {
                    num_acceptedLeads = 0;
                    Revenue = 0;
                    failedFilters = 0;
                    RejectedLeads = 0;
                    UniqueInquirers = 0;
                    UniqueInquries = 0;
                    UniqueStudents = 0;
                    UniqueVisitors = 0;
                    Visits = 0;

                    Object.keys(selectedSource).forEach(function (key) {
                        if (selectedSource[key].value == rData.source) {
                            num_acceptedLeads = rData.acceptedLeads;
                            Revenue = rData.partnerRevenue;
                            failedFilters = rData.failedFilters;
                            RejectedLeads = rData.rejectedLeads;
                            UniqueInquirers = rData.uniqueInquirers;
                            UniqueInquries = rData.uniqueInquries;
                            UniqueStudents = rData.uniqueStudents;
                            UniqueVisitors = rData.uniqueVisitors;
                            Visits = rData.visits;
                        }
                    });
                } else {
                    num_acceptedLeads = rData.acceptedLeads;
                    Revenue = rData.partnerRevenue;
                    failedFilters = rData.failedFilters;
                    RejectedLeads = rData.rejectedLeads;
                    UniqueInquirers = rData.uniqueInquirers;
                    UniqueInquries = rData.uniqueInquries;
                    UniqueStudents = rData.uniqueStudents;
                    UniqueVisitors = rData.uniqueVisitors;
                    Visits = rData.visits;
                }
            }

            FilterPassRates = ((RejectedLeads + num_acceptedLeads) / UniqueInquries) * 100;
            FilterPassRates = isFinite(FilterPassRates) ? Math.round(FilterPassRates * 10) / 10 : 0;

            UniqueConversionRate = (UniqueStudents / UniqueVisitors) * 100;
            UniqueConversionRate = isFinite(UniqueConversionRate)
                ? Math.round(UniqueConversionRate * 10) / 10
                : 0;

            RevenueperStudent = Revenue / UniqueStudents;
            RevenueperStudent = isFinite(RevenueperStudent)
                ? Math.round(RevenueperStudent * 100) / 100
                : 0;

            RejectionRate = (RejectedLeads / (RejectedLeads + num_acceptedLeads)) * 100;
            RejectionRate = isFinite(RejectionRate) ? Math.round(RejectionRate * 10) / 10 : 0;

            LeadsperStudent = num_acceptedLeads / UniqueStudents;
            LeadsperStudent = isFinite(LeadsperStudent) ? Math.round(LeadsperStudent * 10) / 10 : 0;

            RevenueperAcceptedLead = Revenue / num_acceptedLeads;
            RevenueperAcceptedLead = isFinite(RevenueperAcceptedLead)
                ? Math.round(RevenueperAcceptedLead * 100) / 100
                : 0;

            months[rData.dateTimeAgg] = {
                date: rData.timestamp,
                total_AcceptedLeads: num_acceptedLeads,
                total_failedFilters: failedFilters,
                FilterPassRates: FilterPassRates,
                LeadsperStudent: LeadsperStudent,
                RejectedLeads: RejectedLeads,
                RejectionRate: RejectionRate,
                RevenueperAcceptedLead: RevenueperAcceptedLead,
                RevenueperStudent: RevenueperStudent,
                UniqueConversionRate: UniqueConversionRate,
                UniqueInquirers: UniqueInquirers,
                UniqueInquries: UniqueInquries,
                UniqueStudents: UniqueStudents,
                UniqueVisitors: UniqueVisitors,
                Visits: Visits,
                total_Revenue: Revenue,
            };
        });

    let cYear = 'p-1 shadow border border-black rounded ml-1 mb-2 text-xs';
    let cWeek = 'p-1 shadow border border-black rounded ml-1 mb-2 text-xs';
    let cDay = 'p-1 shadow border border-black rounded ml-1 mb-2 text-xs';
    let cMonth = 'p-1 shadow border border-black rounded ml-1 mb-2 text-xs';
    let lastDay = 'p-1 shadow border border-black rounded ml-1 mb-2 text-xs';
    let last7day = 'p-1 shadow border border-black rounded ml-1 mb-2 text-xs';
    let last12Weeks = 'p-1 shadow border border-black rounded ml-1 mb-2 text-xs';
    let last30days = 'p-1 shadow border border-black rounded ml-1 mb-2 text-xs';
    let last4weeks = 'p-1 shadow border border-black rounded ml-1 mb-2 text-xs';
    let lastweek = 'p-1 shadow border border-black rounded ml-1 mb-2 text-xs';
    let lastmonth = 'p-1 shadow border border-black rounded ml-1 mb-2 text-xs';
    let lastyear = 'p-1 shadow border border-black rounded ml-1 mb-2 text-xs';
    let last8weeks = 'p-1 shadow border border-black rounded ml-1 mb-2 text-xs';
    let chartTitle = 'Today (by hour)';
    let tableTitle = 'Today';
    let dateFormateTooltip = 'HH:mm';

    if (props.activeEle) {
        if (props.activeEle.id === 'current-year') {
            cYear = 'p-1 shadow border border-black rounded ml-1 mb-2 text-xs bg-orange text-white';
            chartTitle = 'Current Year (by month)';
            tableTitle = 'Current Year';
            chartXLabel = 'Months';
            dateFormateTooltip = 'MMM yyyy';
        } else if (props.activeEle.id === 'current-week') {
            cWeek = 'p-1 shadow border border-black rounded ml-1 mb-2 text-xs bg-orange text-white';
            chartTitle = 'Current Week';
            tableTitle = 'Current Week';
            chartXLabel = 'Current Week';
            dateFormateTooltip = 'dd MMM yyyy';
        } else if (props.activeEle.id === 'current-month') {
            cMonth =
                'p-1 shadow border border-black rounded ml-1 mb-2 text-xs bg-orange text-white';
            chartTitle = 'Current Month (by day)';
            tableTitle = 'Current Month';
            chartXLabel = 'Days';
            dateFormateTooltip = 'dd MMM yyyy';
        } else if (props.activeEle.id === 'current-day') {
            chartTitle = 'Today (by hour)';
            tableTitle = 'Today';
            chartXLabel = 'Hours';
            cDay = 'p-1 shadow border border-black rounded ml-1 mb-2 text-xs bg-orange text-white';
            dateFormateTooltip = 'HH:mm';
        } else if (props.activeEle.id === 'last-day') {
            chartTitle = 'Yesterday (by hour)';
            tableTitle = 'Yesterday';
            chartXLabel = 'Hours';
            lastDay =
                'p-1 shadow border border-black rounded ml-1 mb-2 text-xs bg-orange text-white';
            dateFormateTooltip = 'HH:mm';
        } else if (props.activeEle.id === 'last-7-days') {
            chartTitle = 'Last 7 Days';
            tableTitle = 'Last 7 Days';
            chartXLabel = 'Days';
            last7day =
                'p-1 shadow border border-black rounded ml-1 mb-2 text-xs bg-orange text-white';
            dateFormateTooltip = 'dd MMM yyyy';
        } else if (props.activeEle.id === 'last-12-weeks') {
            chartTitle = 'Last 12 Weeks (by week)';
            tableTitle = 'Last 12 Weeks';
            chartXLabel = 'Weeks';
            last12Weeks =
                'p-1 shadow border border-black rounded ml-1 mb-2 text-xs bg-orange text-white';
            dateFormateTooltip = 'dd MMM yyyy';
        } else if (props.activeEle.id === 'last-30-days') {
            chartTitle = 'Last 30 Days';
            tableTitle = 'Last 30 Days';
            chartXLabel = 'Days';
            last30days =
                'p-1 shadow border border-black rounded ml-1 mb-2 text-xs bg-orange text-white';
            dateFormateTooltip = 'dd MMM yyyy';
        } else if (props.activeEle.id === 'last-4-weeks') {
            chartTitle = 'Last 4 Weeks (by week)';
            tableTitle = 'Last 4 Weeks';
            chartXLabel = 'Weeks';
            last4weeks =
                'p-1 shadow border border-black rounded ml-1 mb-2 text-xs bg-orange text-white';
            dateFormateTooltip = 'dd MMM yyyy';
        } else if (props.activeEle.id === 'last-week') {
            chartTitle = 'Last Week (by day)';
            tableTitle = 'Last Week';
            chartXLabel = 'Days';
            lastweek =
                'p-1 shadow border border-black rounded ml-1 mb-2 text-xs bg-orange text-white';
            dateFormateTooltip = 'dd MMM yyyy';
        } else if (props.activeEle.id === 'last-month') {
            chartTitle = 'Last Month (by day)';
            tableTitle = 'Last Month';
            chartXLabel = 'Days';
            lastmonth =
                'p-1 shadow border border-black rounded ml-1 mb-2 text-xs bg-orange text-white';
            dateFormateTooltip = 'dd MMM yyyy';
        } else if (props.activeEle.id === 'last-year') {
            chartTitle = 'Last Year (by month)';
            tableTitle = 'Last Year';
            chartXLabel = 'Months';
            lastyear =
                'p-1 shadow border border-black rounded ml-1 mb-2 text-xs bg-orange text-white';
            dateFormateTooltip = 'MMM yyyy';
        } else if (props.activeEle.id === 'last-8-weeks') {
            chartTitle = 'Last 8 Weeks (by week)';
            tableTitle = 'Last 8 Weeks';
            chartXLabel = 'Weeks';
            last8weeks =
                'p-1 shadow border border-black rounded ml-1 mb-2 text-xs bg-orange text-white';
            dateFormateTooltip = 'dd MMM yyyy';
        }
    } else {
        cDay = 'p-1 shadow border border-black rounded ml-1 mb-2 text-xs bg-orange text-white';
        dateFormateTooltip = 'HH:mm';
        chartXLabel = 'Hours';
    }

    columns = [
        {id: 'first', displayName: chartXLabel},
        {id: 'second', displayName: 'Your Revenue'},
        {id: 'third', displayName: 'Visits'},
        {id: 'fourth', displayName: 'Unique Inquirers'},
        {id: 'fifth', displayName: 'Unique Inquries'},
        {id: 'six', displayName: 'Unique Students'},
        {id: 'seven', displayName: 'Failed Filters'},
        {id: 'eight', displayName: 'Rejected Leads'},
        {id: 'nine', displayName: 'Acepted Leads'},
        {id: 'ten', displayName: 'Unique Visitors'},
        {id: 'eleven', displayName: 'Unique Conversion Rate (%)'},
        {id: 'twelve', displayName: 'Revenue per Student ($)'},
        {id: 'thirteen', displayName: 'Filter Pass Rate (%)'},
        {id: 'fourteen', displayName: 'Rejection Rate (%)'},
        {id: 'fifteen', displayName: 'Leads per Student'},
        {id: 'sixteen', displayName: 'Revenue per Accepted Lead ($)'},
    ];

    let output = [
        [
            {type: 'datetime', label: chartXLabel},
            {type: 'number', label: 'Your Revenue'},
            {type: 'number', label: 'Visits'},
            {type: 'number', label: 'Unique Inquirers'},
            {type: 'number', label: 'Unique Inquries'},
            {type: 'number', label: 'Unique Students'},
            {type: 'number', label: 'Failed Filters'},
            {type: 'number', label: 'Rejected Leads'},
            {type: 'number', label: 'Acepted Leads'},
            {type: 'number', label: 'Unique Visitors'},
            {type: 'number', label: 'Unique Conversion Rate (%)'},
            {type: 'number', label: 'Revenue per Student ($)'},
            {type: 'number', label: 'Filter Pass Rate (%)'},
            {type: 'number', label: 'Rejection Rate (%)'},
            {type: 'number', label: 'Leads per Student'},
            {type: 'number', label: 'Revenue per Accepted Lead ($)'},
        ],
    ];

    let printoutput = [
        [
            {type: 'datetime', label: chartXLabel},
            {type: 'string', label: 'Your Revenue'},
            {type: 'number', label: 'Visits'},
            {type: 'number', label: 'Unique Inquirers'},
            {type: 'number', label: 'Unique Inquries'},
            {type: 'number', label: 'Unique Students'},
            {type: 'number', label: 'Failed Filters'},
            {type: 'number', label: 'Rejected Leads'},
            {type: 'number', label: 'Acepted Leads'},
            {type: 'number', label: 'Unique Visitors'},
            {type: 'number', label: 'Unique Conversion Rate (%)'},
            {type: 'string', label: 'Revenue per Student ($)'},
            {type: 'number', label: 'Filter Pass Rate (%)'},
            {type: 'number', label: 'Rejection Rate (%)'},
            {type: 'number', label: 'Leads per Student'},
            {type: 'string', label: 'Revenue per Accepted Lead ($)'},
        ],
    ];

    let columnTitle = ['Accpted Leads', 'Your Revenue'];
    const tifOptions = Object.keys(months).map(key => {
        output.push([
            new Date(months[key]['date']),
            months[key]['total_Revenue'],
            months[key]['Visits'],
            months[key]['UniqueInquirers'],
            months[key]['UniqueInquries'],
            months[key]['UniqueStudents'],
            months[key]['total_failedFilters'],
            months[key]['RejectedLeads'],
            months[key]['total_AcceptedLeads'],
            months[key]['UniqueVisitors'],
            months[key]['UniqueConversionRate'],
            months[key]['RevenueperStudent'],
            months[key]['FilterPassRates'],
            months[key]['RejectionRate'],
            months[key]['LeadsperStudent'],
            months[key]['RevenueperAcceptedLead'],
        ]);

        printoutput.push([
            new Date(months[key]['date']),
            {
                v: months[key]['total_Revenue'],
                f: '$' + months[key]['total_Revenue'].toFixed(2),
            },
            months[key]['Visits'],
            months[key]['UniqueInquirers'],
            months[key]['UniqueInquries'],
            months[key]['UniqueStudents'],
            months[key]['total_failedFilters'],
            months[key]['RejectedLeads'],
            months[key]['total_AcceptedLeads'],
            months[key]['UniqueVisitors'],
            months[key]['UniqueConversionRate'],
            {
                v: months[key]['RevenueperStudent'],
                f: '$' + months[key]['RevenueperStudent'].toFixed(2),
            },
            months[key]['FilterPassRates'],
            months[key]['RejectionRate'],
            months[key]['LeadsperStudent'],
            {
                v: months[key]['RevenueperAcceptedLead'],
                f: '$' + months[key]['RevenueperAcceptedLead'].toFixed(2),
            },
        ]);
    });
    const datas = Object.keys(months).map(key =>
        csvDatas.push([
            //new Date(key),
            new Date(months[key]['date']),
            '$' + months[key]['total_Revenue'].toFixed(2),
            months[key]['Visits'],
            months[key]['UniqueInquirers'],
            months[key]['UniqueInquries'],
            months[key]['UniqueStudents'],
            months[key]['total_failedFilters'],
            months[key]['RejectedLeads'],
            months[key]['total_AcceptedLeads'],
            months[key]['UniqueVisitors'],
            months[key]['UniqueConversionRate'],
            '$' + months[key]['RevenueperStudent'].toFixed(2),
            months[key]['FilterPassRates'],
            months[key]['RejectionRate'],
            months[key]['LeadsperStudent'],
            '$' + months[key]['RevenueperAcceptedLead'].toFixed(2),
        ])
    );
    var acceptLeads = 0;
    var finalTotalUniqueStudents = 0;
    var partnerRevenue = 0;
    let startPeriod = new Date();
    let endPeriod = new Date();
    let chartDateRange = [];
    let index;
    if (chartdata && chartdata.length > 0) {
        let totalLead = 0;
        let totalUniqueStidents = 0;
        let totalRevenue = 0;
        for (index = 0; index < chartdata.length; index++) {
            if (index == 0) {
                //startPeriod = new Date(chartdata[index].timestamp);
                startPeriod = new Date(chartdata[index].startDate);
                endPeriod = new Date(chartdata[index].endDate);
            }
            /* if (index == chartdata.length - 1) {
         endPeriod = new Date(chartdata[index].timestamp);
       }*/

            if (
                selectedOption != null &&
                0 < selectedOption.length &&
                selectedSource != null &&
                0 < selectedSource.length
            ) {
                Object.keys(selectedOption).forEach(function (key) {
                    Object.keys(selectedSource).forEach(function (skey) {
                        if (
                            selectedOption[key].value == chartdata[index].domain &&
                            selectedSource[skey].value == chartdata[index].source
                        ) {
                            totalRevenue = totalRevenue + chartdata[index].partnerRevenue;
                            totalLead = totalLead + chartdata[index].acceptedLeads;
                            totalUniqueStidents =
                                totalUniqueStidents + chartdata[index].uniqueStudents;
                        }
                    });
                });
            } else if (null !== selectedOption && 0 < selectedOption.length) {
                Object.keys(selectedOption).forEach(function (key) {
                    if (selectedOption[key].value == chartdata[index].domain) {
                        totalRevenue = totalRevenue + chartdata[index].partnerRevenue;
                        totalLead = totalLead + chartdata[index].acceptedLeads;
                        totalUniqueStidents = totalUniqueStidents + chartdata[index].uniqueStudents;
                    }
                });
            } else if (null !== selectedSource && 0 < selectedSource.length) {
                Object.keys(selectedSource).forEach(function (key) {
                    if (selectedSource[key].value == chartdata[index].source) {
                        totalRevenue = totalRevenue + chartdata[index].partnerRevenue;
                        totalLead = totalLead + chartdata[index].acceptedLeads;
                        totalUniqueStidents = totalUniqueStidents + chartdata[index].uniqueStudents;
                    }
                });
            } else {
                totalRevenue = totalRevenue + chartdata[index].partnerRevenue;
                totalLead = totalLead + chartdata[index].acceptedLeads;
                totalUniqueStidents = totalUniqueStidents + chartdata[index].uniqueStudents;
            }

            partnerRevenue = totalRevenue;
            acceptLeads = totalLead;
            finalTotalUniqueStudents = totalUniqueStidents;
            console.log(totalUniqueStidents);
        }
    } else {
        if (typeof defaultData !== 'undefined') {
            startPeriod = new Date(defaultData.startPeriod).getTime();
            endPeriod = new Date(defaultData.endPeriod).getTime();
        }
    }

    const SelecthandleChange = (event, newValue) => {
        setOption(event);
        // console.log('selectedOption', selectedOption)
        // console.log('selectedOption', selectedSource)
        // console.log(event);
        // setpartnerRevenue_2(0);
        //setacceptLeads_2(0);
        let totalLead = 0;
        let totalUniqueStidents = 0;
        let totalRevenue = 0;

        if (chartdata && chartdata.length > 0) {
            for (index = 0; index < chartdata.length; index++) {
                if (
                    event != null &&
                    0 < event.length &&
                    selectedSource != null &&
                    0 < selectedSource.length
                ) {
                    Object.keys(event).forEach(function (key) {
                        Object.keys(selectedSource).forEach(function (skey) {
                            if (
                                event[key].value == chartdata[index].domain &&
                                selectedSource[skey].value == chartdata[index].source
                            ) {
                                console.log(
                                    index,
                                    chartdata[index].partnerRevenue,
                                    chartdata[index].acceptedLeads,
                                    chartdata[index].uniqueStudents
                                );
                                totalRevenue = totalRevenue + chartdata[index].partnerRevenue;
                                totalLead = totalLead + chartdata[index].acceptedLeads;
                                totalUniqueStidents =
                                    totalUniqueStidents + chartdata[index].uniqueStudents;
                                console.log(
                                    index,
                                    chartdata[index].partnerRevenue,
                                    chartdata[index],
                                    chartdata[index].uniqueStudents,
                                    totalUniqueStidents
                                );
                            }
                        });
                    });
                } else if (event != null && 0 < event.length) {
                    Object.keys(event).forEach(function (key) {
                        if (event[key].value == chartdata[index].domain) {
                            console.log(index, chartdata);
                            totalRevenue = totalRevenue + chartdata[index].partnerRevenue;
                            totalLead = totalLead + chartdata[index].acceptedLeads;
                            totalUniqueStidents =
                                totalUniqueStidents + chartdata[index].uniqueStudents;
                        }
                    });
                } else {
                    console.log(index, chartdata);
                    totalRevenue = totalRevenue + chartdata[index].partnerRevenue;
                    totalLead = totalLead + chartdata[index].acceptedLeads;
                    totalUniqueStidents = totalUniqueStidents + chartdata[index].uniqueStudents;
                }

                partnerRevenue = totalRevenue;
                acceptLeads = totalLead;
                finalTotalUniqueStudents = totalUniqueStidents;
                console.log(totalUniqueStidents);
            }
        }

        /*if (event == null || event.length == 0) {
      partnerRevenue = 0;
      acceptLeads = 0;
    } else {
      partnerRevenue = totalRevenue;
      acceptLeads = totalLead;
    }*/
    };
    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    let filter_Options = [];

    filter_Options.push(
        {value: 8, label: 'Accepted Leads'},
        {value: 6, label: 'Failed FIlters'},
        {value: 12, label: 'Filter Pass Rate (%)'},
        {value: 14, label: 'Leads per Student'},
        {value: 7, label: 'Rejected Leads'},
        {value: 13, label: 'Rejection Rate (%)'},
        {value: 15, label: 'Revenue per Accepted Lead ($)'},
        {value: 11, label: 'Revenue per Student ($)'},
        {value: 10, label: 'Unique Conversion Rate (%)'},
        {value: 3, label: 'Unique Inquirers'},
        {value: 4, label: 'Unique Inquries'},
        {value: 5, label: 'Unique Students'},
        {value: 9, label: 'Unique Visitors'},
        {value: 2, label: 'Visits'},
        {value: 1, label: 'Your Revenue'}
    );
    const Filter_one_SelecthandleChange = (event, newValue) => {
        setFilter_oneSelectedOption(event);
    };

    const selectSourceChange = (event, newValue) => {
        selectSource(event);
    };

    const Filter_second_SelecthandleChange = (event, newValue) => {
        setFilter_secondSelectedOption(event);
    };

    let nodataText = "<div class='spinner'></div>";
    if (props.chartLoading && chartdata) {
        nodataText = "<div class='spinner'></div>";
    } else if (props.chartLoading && chartdata == null) {
        nodataText = "<div class='spinner'></div>";
    } else {
        nodataText = 'No data available!';
    }
    var chartType = 'bar';
    const ActiveChartType = (event, newValue) => {
        setBarChartType('shadow border border-black rounded ml-1 mt-3 mb-2 text-xs');
        setLineChartType('shadow border border-black rounded ml-1 mt-3 mb-2 text-xs');

        if (event.currentTarget.id === 'BarChartType') {
            setBarChartType(
                'shadow border bg-orange text-white border-black rounded ml-1 mt-3 mb-2 text-xs'
            );
            setbarChartClass('w-full sm:w-1/1 w-4/5  mr-3 mb-3 p-3 float-left text-center');
            setlineChartClass('w-full sm:w-1/1 w-4/5  mr-3 mb-3 p-3 float-left text-center hidden');
            chartType = 'bar';
        } else {
            setLineChartType(
                'shadow border bg-orange text-white border-black rounded ml-1 mt-3 mb-2 text-xs'
            );
            setbarChartClass('w-full sm:w-1/1 w-4/5  mr-3 mb-3 p-3 float-left text-center hidden');
            setlineChartClass('w-full sm:w-1/1 w-4/5  mr-3 mb-3 p-3 float-left text-center');
            chartType = 'line';
        }
    };
    let startPeriodDate, endPeriodDate;
    const handleRangeData = data => {
        let totalRevenue = 0;
        let totalLead = 0;
        const startDate = (new Date(data.range.start).getTime() / 1000).toFixed(0);
        const endDate = (new Date(data.range.end).getTime() / 1000).toFixed(0);
        let filteredTableData = [
            [
                {type: 'date', label: chartXLabel},
                {type: 'number', label: 'Your Revenue'},
                {type: 'number', label: 'Visits'},
                {type: 'number', label: 'Unique Inquirers'},
                {type: 'number', label: 'Unique Inquries'},
                {type: 'number', label: 'Unique Students'},
                {type: 'number', label: 'Failed Filters'},
                {type: 'number', label: 'Rejected Leads'},
                {type: 'number', label: 'Acepted Leads'},
                {type: 'number', label: 'Unique Visitors'},
                {type: 'number', label: 'Unique Conversion Rate (%)'},
                {type: 'number', label: 'Revenue per Student ($)'},
                {type: 'number', label: 'Filter Pass Rate (%)'},
                {type: 'number', label: 'Rejection Rate (%)'},
                {type: 'number', label: 'Leads per Student'},
                {type: 'number', label: 'Revenue per Accepted Lead ($)'},
            ],
        ];

        let filteredCsvData = [];
        const tableChartData = output.map((item, index) => {
            if (index !== 0) {
                if (
                    startDate < (new Date(item[0]).getTime() / 1000).toFixed(0) &&
                    endDate > (new Date(item[0]).getTime() / 1000).toFixed(0)
                ) {
                    filteredTableData.push([
                        new Date(item[0]),
                        item[1],
                        item[2],
                        item[3],
                        item[4],
                        item[5],
                        item[6],
                        item[7],
                        item[8],
                        item[9],
                        item[10],
                        item[11],
                        item[12],
                        item[13],
                        item[14],
                        item[15],
                    ]);

                    filteredCsvData.push([
                        new Date(item[0]),
                        item[1],
                        item[2],
                        item[3],
                        item[4],
                        item[5],
                        item[6],
                        item[7],
                        item[8],
                        item[9],
                        item[10],
                        item[11],
                        item[12],
                        item[13],
                        item[14],
                        item[15],
                    ]);
                    totalRevenue = totalRevenue + item[1];
                    totalLead = totalLead + item[8];
                }
            }
        });
        startPeriodDate = new Date(filteredCsvData[0][0]);
        endPeriodDate = new Date(filteredCsvData[filteredCsvData.length - 1][0]);
        const TableFilterData = () => {
            return (
                <div>
                    <h3 className="tableTitle p-1">{tableTitle}</h3>
                    <div className="download-csv float-right">
                        {filteredCsvData != null && (
                            <CsvDownloader
                                filename="ASDDataFile"
                                separator=";"
                                columns={columns}
                                datas={filteredCsvData}
                                text="Download Filtered Data"
                            />
                        )}
                    </div>
                    {filteredTableData != null ? (
                        <Chart
                            chartType="Table"
                            data={filteredTableData}
                            formatters={[
                                {
                                    type: 'DateFormat',
                                    column: 0,
                                    options: {
                                        pattern: 'MMM d, YYY, H:MM:SS aa',
                                    },
                                },
                            ]}
                            options={{
                                cssClassNames: {
                                    tableCell: 'tableCell',
                                },
                            }}
                        />
                    ) : (
                        ReactHtmlParser(nodataText)
                    )}
                </div>
            );
        };
        ReactDom.render(<TableFilterData />, document.getElementById('table-data'));

        const TotalLeadQuickState = () => {
            return (
                <span>
                    <NumberFormat
                        value={totalLead != null ? totalLead : 0}
                        displayType={'text'}
                        thousandSeparator={true}
                    />
                </span>
            );
        };
        ReactDom.render(<TotalLeadQuickState />, document.getElementById('total_leads'));

        const TotalUniqeStudentskState = () => {
            return (
                <span>
                    <NumberFormat
                        value={finalTotalUniqueStudents != null ? finalTotalUniqueStudents : 0}
                        displayType={'text'}
                        thousandSeparator={true}
                    />
                </span>
            );
        };
        ReactDom.render(
            <TotalUniqeStudentskState />,
            document.getElementById('total_unique_students')
        );

        const PartnerRevenueQuickState = () => {
            return (
                <span>
                    <NumberFormat
                        value={totalRevenue != null ? totalRevenue : 0}
                        prefix={'$'}
                        decimalScale="2"
                        displayType={'text'}
                        thousandSeparator={true}
                    />
                </span>
            );
        };
        ReactDom.render(<PartnerRevenueQuickState />, document.getElementById('total_revenue'));

        const DateQuickState = () => {
            return (
                <span>
                    {dataLoad ? <Moment format="MMM D,Y">{startPeriodDate}</Moment> : ''}
                    &nbsp; - &nbsp;<br></br>
                    {dataLoad ? <Moment format="MMM D,Y">{endPeriodDate}</Moment> : ''}
                </span>
            );
        };
        ReactDom.render(<DateQuickState />, document.getElementById('time_period'));
    };
    let InpersonateButton;
    const inpersonateUser = localStorage.getItem('inpersonate_user')
        ? localStorage.getItem('inpersonate_user')
        : '';
    if (inpersonateFlag === 'true') {
        InpersonateButton = () => {
            return (
                // <div className="inpersonate-user-section">
                //   <button onClick={handleBacktoLoginUser} className="back-btn bg-orange hover:bg-gray-100 text-gray-800 font-semibold border border-gray-400 rounded shadow text-white" data-impersonation="false" id="2">
                //     <svg className="MuiSvgIcon-root jss67 back-icon" focusable="false" viewBox="0 0 24 24" aria-hidden="true" tabIndex="-1" title="ArrowBackIos" data-ga-event-category="material-icons" data-ga-event-action="click" data-ga-event-label="ArrowBackIos"><path d="M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"></path></svg>
                //     <span className="inpersonate-name">Back to regular user</span>
                //   </button>
                //   <span className="user-btn markdown-body reset text-gray-800 font-semibold border border-gray-400 rounded shadow">
                //     <svg className="MuiSvgIcon-root jss373 person" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation" tabIndex="-1" title="People"><path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"></path></svg>
                //     <span className="name">{inpersonateUser}</span></span>
                // </div>
                ''
            );
        };
    } else {
        InpersonateButton = () => {
            return '';
        };
    }

    const handleBacktoLoginUser = (event, newValue) => {
        if (event.currentTarget.attributes.getNamedItem('data-impersonation').value === 'true') {
            localStorage.setItem('inpersonate', true);
        } else {
            localStorage.setItem('inpersonate', false);
        }
        const get_token = localStorage.getItem('token');
        const user_id = localStorage.getItem('userId');
        const requestOptions = {
            method: 'POST',
            mode: 'cors',
            body: JSON.stringify({get_token: get_token, user_id: user_id}),
        };
        if (event.currentTarget.id != '') {
            fetch(`./wp-json/asd/users/inpersonate`, requestOptions)
                .then(response => response.json())
                .then(userData => {
                    if (
                        'jwt_auth_invalid_token' === userData.code ||
                        'jwt_auth_bad_iss' === userData.code
                    ) {
                        localStorage.removeItem('token');
                        window.location.href = '/asd-login';
                    } else if ('jwt_auth_bad_request' === userData.code) {
                        if (userData.message) {
                            alert(userData.message);
                        }
                    } else if (userData != null) {
                        if (userData.token != null) {
                            localStorage.setItem('token', userData.token);
                            window.location.href = './';
                        }
                    }
                });
        }
    };

    const report_options = [
        {value: 'Select Report', label: 'Select Report'},
        {
            value: 'external_partner_lead_detailed_report',
            label: 'External partner lead detail report',
        },
        {
            value: 'external_partner_lead_summary_report',
            label: 'External partner lead summary report',
        },
        {
            value: 'credit_lead_return_resason_report',
            label: 'Credit leads return reason report',
        },
        {
            value: 'interaday_external_partner_lead_detailed_report',
            label: 'Intraday external partner lead detail report',
        },
        {
            value: 'unique_student_report',
            label: 'Unique Student Report (Return Details)',
        },
        // unique_student_report
    ];

    return (
        <React.Fragment>
            <main className="main-wrap">
                <div className={classes.root}>
                    <AppBar position="static" color="default" className="header-wrap">
                        <Tabs
                            value={value}
                            onChange={TabhandleChange}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="scrollable"
                            scrollButtons="auto"
                            aria-label="scrollable auto tabs example"
                            className="tabs-wrapper"
                        >
                            <Tab label="Dashboard" {...a11yProps(0)} />
                            <Tab label="Documents" {...a11yProps(1)} />
                            <Tab label="Reports" {...a11yProps(2)} />
                            <Tab label="Tags" {...a11yProps(3)} />
                            <Tab label="Billing" {...a11yProps(4)} />
                            {/* TESTING TAGS TAB */}
                        </Tabs>
                    </AppBar>
                    <TabPanel value={value} index={0}>
                        <div className="w-full mb-3 mx-auto flex flex-wrap  mt-0 px-6 pb-6 pt-2 wrapper">
                            <div className="lg:w-1/6 xl:w-1/6 w-full sm:w-1/1 w-1/6  mr-3 mb-3 p-6 bg-white border rounded shadow h-full dashboard-right-column">
                                <h3 className="text-base flex mb-4">
                                    <AssessmentIcon className="bg-orange text-white mr-2" /> Quick
                                    Stats
                                </h3>
                                <hr className="quick-separator"></hr>
                                <h4 className="font-light text-sm">
                                    Leads:
                                    <span
                                        className="w-full float-left text-left pl-6 font-semibold mb-4 mt-1"
                                        id="total_leads"
                                    >
                                        <NumberFormat
                                            value={acceptLeads ? acceptLeads : 0}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                        />
                                    </span>
                                </h4>
                                <h4 className="font-light text-sm">
                                    Unique Students:
                                    <span
                                        className="w-full float-left text-left pl-6 font-semibold mb-4 mt-1"
                                        id="total_unique_students"
                                    >
                                        <NumberFormat
                                            value={
                                                finalTotalUniqueStudents
                                                    ? finalTotalUniqueStudents
                                                    : 0
                                            }
                                            displayType={'text'}
                                            thousandSeparator={true}
                                        />
                                    </span>
                                </h4>
                                <h4 className="font-light text-sm">
                                    Your Revenue:
                                    <span
                                        className="w-full float-left text-left pl-6 font-semibold mb-4 mt-1"
                                        id="total_revenue"
                                    >
                                        <NumberFormat
                                            value={partnerRevenue ? partnerRevenue : 0}
                                            prefix={'$'}
                                            decimalScale="2"
                                            displayType={'text'}
                                            thousandSeparator={true}
                                        />
                                    </span>
                                </h4>
                                <h4 className="font-light text-sm">
                                    Time Period:
                                    <span
                                        className="w-full float-left text-left pl-6 font-semibold mt-1"
                                        id="time_period"
                                    >
                                        {dataLoad ? (
                                            <Moment format="MMM D,Y">{startPeriod}</Moment>
                                        ) : (
                                            ''
                                        )}
                                        &nbsp; - &nbsp;<br></br>
                                        {dataLoad ? (
                                            <Moment format="MMM D,Y">{endPeriod}</Moment>
                                        ) : (
                                            ''
                                        )}
                                    </span>
                                </h4>
                            </div>
                            <div className="lg:w-4/5 xl:w-4/5 w-full sm:w-1/1 w-4/5  mr-3 mb-3 p-3 bg-white border rounded shadow h-full filter-wrap">
                                <div className="pt-6 mt-3 float-right inpersonate-user">
                                    <InpersonateButton />
                                </div>
                                <div className="lg:w-1/5 xl:w-1/5 w-full sm:w-1/1 w-1/6  mb-3 float-left p-1 mt-1 flex flex-wrap items-center">
                                    <h3 className="float-left text-sm">Current:</h3>
                                    <button
                                        id="current-day"
                                        onClick={props.FilterChartfunc}
                                        className={cDay}
                                    >
                                        1d
                                    </button>
                                    <button
                                        id="current-week"
                                        onClick={props.FilterChartfunc}
                                        className={cWeek}
                                    >
                                        1w
                                    </button>
                                    <button
                                        id="current-month"
                                        onClick={props.FilterChartfunc}
                                        className={cMonth}
                                    >
                                        1m
                                    </button>
                                    <button
                                        id="current-year"
                                        onClick={props.FilterChartfunc}
                                        className={cYear}
                                    >
                                        1y
                                    </button>
                                </div>
                                <div className="lg:w-1/4 xl:w-1/4 w-full sm:w-1/1 w-1/3 p-1 mb-3 float-left p-1 mt-1 flex flex-wrap items-center">
                                    <h3 className="float-left text-sm">Last:</h3>
                                    <button
                                        id="last-day"
                                        onClick={props.FilterChartfunc}
                                        className={lastDay}
                                    >
                                        1d
                                    </button>
                                    <button
                                        id="last-7-days"
                                        onClick={props.FilterChartfunc}
                                        className={last7day}
                                    >
                                        7d
                                    </button>
                                    <button
                                        id="last-30-days"
                                        onClick={props.FilterChartfunc}
                                        className={last30days}
                                    >
                                        30d
                                    </button>
                                    <button
                                        id="last-week"
                                        onClick={props.FilterChartfunc}
                                        className={lastweek}
                                    >
                                        1w
                                    </button>
                                    <button
                                        id="last-4-weeks"
                                        onClick={props.FilterChartfunc}
                                        className={last4weeks}
                                    >
                                        4w
                                    </button>
                                    <button
                                        id="last-8-weeks"
                                        onClick={props.FilterChartfunc}
                                        className={last8weeks}
                                    >
                                        8w
                                    </button>
                                    <button
                                        id="last-12-weeks"
                                        onClick={props.FilterChartfunc}
                                        className={last12Weeks}
                                    >
                                        12w
                                    </button>
                                    <button
                                        id="last-month"
                                        onClick={props.FilterChartfunc}
                                        className={lastmonth}
                                    >
                                        1m
                                    </button>
                                    <button
                                        id="last-year"
                                        onClick={props.FilterChartfunc}
                                        className={lastyear}
                                    >
                                        1y
                                    </button>
                                </div>
                                <div className="lg:w-1/4 xl:w-1/4 w-full sm:w-1/1 w-1/2 p-1 mb-3 float-left p-1 mt-2 flex items-center">
                                    <h3 className="float-left mr-2 text-sm">Source: </h3>
                                    <Select2
                                        isMulti
                                        value={selectedSource}
                                        onChange={selectSourceChange}
                                        options={uniqueSourceOptions}
                                        style={{width: '250px'}}
                                        placeholder="All"
                                        simpleValue
                                        className="text-xs flex-1"
                                    />
                                </div>
                                <div className="lg:w-1/4 xl:w-1/4 w-full sm:w-1/1 w-1/2 p-1 mb-3 float-left p-1 mt-1 flex items-center">
                                    <h3 className="float-left mr-2 text-sm">Domains: </h3>
                                    <Select2
                                        isMulti
                                        value={selectedOption}
                                        onChange={SelecthandleChange}
                                        options={options}
                                        style={{width: '250px'}}
                                        placeholder="All"
                                        simpleValue
                                        className="text-xs flex-1"
                                    />
                                </div>
                                <div className="lg:w-1/2 xl:w-1/2 w-full sm:w-1/1 w-1/2 p-1 mb-3 float-right p-1 mb-1">
                                    <div className="w-full sm:w-1/3 w-4/6 ml-2   mb-3 p-2 float-left">
                                        <p className="float-left p-2 bg-blue mr-2 mt-2 shadow-md"></p>
                                        <Select2
                                            value={Filter_oneSelectedOption}
                                            onChange={Filter_one_SelecthandleChange}
                                            options={filter_Options}
                                            style={{width: '250px'}}
                                            placeholder="All"
                                            simpleValue
                                            className="text-xs"
                                        />
                                    </div>
                                    <p className="float-left p-2 mt-1">vs</p>
                                    <div className="w-full sm:w-1/3 w-4/6   mb-3 p-2 float-left">
                                        <p className="float-left p-2 bg-red mr-2 mt-2 shadow-md"></p>
                                        <Select2
                                            value={Filter_secondSelectedOption}
                                            onChange={Filter_second_SelecthandleChange}
                                            options={filter_Options}
                                            style={{width: '250px'}}
                                            placeholder="All"
                                            simpleValue
                                            className="text-xs"
                                        />
                                    </div>
                                    <button
                                        id="BarChartType"
                                        onClick={ActiveChartType}
                                        className={BarChartType}
                                    >
                                        <BarChartIcon />
                                    </button>
                                    <button
                                        id="lineChartType"
                                        onClick={ActiveChartType}
                                        className={LineChartType}
                                    >
                                        <TimelineIcon />
                                    </button>
                                </div>
                                <h3 className="chartTitle p-1">{chartTitle}</h3>
                                <div className={barChartClass}>
                                    {chartdata != null ? (
                                        <Chart
                                            height={'100%'}
                                            width={'100%'}
                                            chartType="Bar"
                                            loader={<div>Loading Chart</div>}
                                            chartWrapperParams={{
                                                view: {
                                                    columns: [
                                                        0,
                                                        Filter_oneSelectedOption.value,
                                                        Filter_secondSelectedOption.value,
                                                    ],
                                                },
                                            }}
                                            data={output}
                                            formatters={[
                                                {
                                                    type: 'DateFormat',
                                                    column: 0,
                                                    options: {
                                                        pattern: dateFormateTooltip,
                                                    },
                                                },
                                            ]}
                                            options={{
                                                title: '',
                                                legend: {
                                                    position: 'none',
                                                },
                                                chartArea: {
                                                    width: '85%',
                                                    bottom: '50',
                                                },
                                                series: {
                                                    0: {axis: 'Temps'},
                                                    1: {axis: 'Daylight'},
                                                },
                                                animation: {
                                                    startup: true,
                                                    easing: 'out',
                                                    duration: 1500,
                                                },
                                                axes: {
                                                    x: {
                                                        format: 'M/d/yy',
                                                    },
                                                    y: {
                                                        Temps: {
                                                            label: Filter_oneSelectedOption.label,
                                                        },
                                                        Daylight: {
                                                            label: Filter_secondSelectedOption.label,
                                                            //direction:-1, slantedText:true, slantedTextAngle:-90
                                                        },
                                                    },
                                                },
                                            }}
                                            controls={[
                                                {
                                                    controlEvents: [
                                                        {
                                                            eventName: 'statechange',
                                                            callback: ({
                                                                chartWrapper,
                                                                controlWrapper,
                                                            }) => {
                                                                handleRangeData(
                                                                    controlWrapper.getState()
                                                                );
                                                            },
                                                        },
                                                    ],
                                                    controlType: 'ChartRangeFilter',
                                                    options: {
                                                        filterColumnIndex: 0,
                                                        ui: {
                                                            chartType: 'BarChart',
                                                            chartOptions: {
                                                                height: 100,
                                                                chartArea: {
                                                                    height: '100%',
                                                                    width: '95%',
                                                                },
                                                                hAxis: {
                                                                    baselineColor: 'none',
                                                                    format: dateFormateTooltip,
                                                                },
                                                            },
                                                        },
                                                    },
                                                    controlPosition: 'bottom',
                                                },
                                            ]}
                                        />
                                    ) : (
                                        ReactHtmlParser(nodataText)
                                    )}
                                </div>
                                <div id="lineChartWrap" className={lineChartClass}>
                                    {chartdata != null ? (
                                        <Chart
                                            width={'100%'}
                                            chartType="LineChart"
                                            loader={<div>Loading Chart</div>}
                                            chartWrapperParams={{
                                                view: {
                                                    columns: [
                                                        0,
                                                        Filter_oneSelectedOption.value,
                                                        Filter_secondSelectedOption.value,
                                                    ],
                                                },
                                            }}
                                            data={output}
                                            options={{
                                                // Use the same chart area width as the control for axis alignment.
                                                chartArea: {
                                                    height: '80%',
                                                    width: '90%',
                                                },
                                                pointSize: '5',
                                                legend: {
                                                    position: 'none',
                                                },

                                                vAxes: [
                                                    {
                                                        title: Filter_oneSelectedOption.label,
                                                        minValue: 0,
                                                    },

                                                    {
                                                        title: Filter_secondSelectedOption.label,
                                                        minValue: 0,
                                                    },
                                                ],
                                                series: {
                                                    0: 0,
                                                    1: {targetAxisIndex: 1},
                                                    2: {targetAxisIndex: 2},
                                                },
                                            }}
                                            rootProps={{'data-testid': '3'}}
                                            chartPackages={['corechart', 'controls']}
                                            controls={[
                                                {
                                                    controlEvents: [
                                                        {
                                                            eventName: 'statechange',
                                                            callback: ({
                                                                chartWrapper,
                                                                controlWrapper,
                                                            }) => {
                                                                handleRangeData(
                                                                    controlWrapper.getState()
                                                                );
                                                            },
                                                        },
                                                    ],
                                                    controlType: 'ChartRangeFilter',
                                                    options: {
                                                        filterColumnIndex: 0,
                                                        ui: {
                                                            chartType: 'LineChart',
                                                            chartOptions: {
                                                                height: 100,
                                                                // chartArea: { height: "100%", width: "95%" },
                                                                chartArea: {
                                                                    height: '100%',
                                                                    width: '95%',
                                                                },
                                                                hAxis: {
                                                                    baselineColor: 'none',
                                                                    format: dateFormateTooltip,
                                                                },
                                                            },
                                                        },
                                                    },
                                                    controlPosition: 'bottom',
                                                },
                                            ]}
                                        />
                                    ) : (
                                        ReactHtmlParser(nodataText)
                                    )}
                                </div>
                            </div>
                            <div
                                className="w-full sm:w-1/1 w-4/5 text-center p-6 bg-white border rounded shadow h-full"
                                id="table-data"
                            >
                                <h3 className="tableTitle p-1">{tableTitle}</h3>
                                <div className="download-csv float-right">
                                    {chartdata != null && (
                                        <CsvDownloader
                                            filename="ASDDataFile"
                                            separator=";"
                                            columns={columns}
                                            datas={csvDatas}
                                            text="Download Filtered Data"
                                        />
                                    )}
                                </div>
                                {chartdata != null ? (
                                    <Chart
                                        chartType="Table"
                                        data={printoutput}
                                        options={{
                                            cssClassNames: {
                                                tableCell: 'tableCell',
                                            },
                                        }}
                                    />
                                ) : (
                                    ReactHtmlParser(nodataText)
                                )}
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        <Documents SelectedTab={value} documents={props.chartLoading} />
                    </TabPanel>
                    <TabPanel value={value} index={3}>
                        <Tags SelectedTab={value} />
                    </TabPanel>
                    <TabPanel value={value} index={4}>
                        <BillingStatements SelectedTab={value} />
                    </TabPanel>
                    <TabPanel value={value} index={2}>
                        <div className="reports-wrap">
                            <div className="dropdownrow">
                                <div className="dropdown-blk">
                                    <Select2
                                        onChange={props.handleChange}
                                        options={props.dashboardReport.reportList}
                                        className="custom-select"
                                        defaultValue={props.dashboardReport.selectedOption}
                                    />
                                </div>

                                <div className="pt-6 mt-3 float-right inpersonate-user">
                                    <div className="float-right subscribe-div">
                                        {' '}
                                        <Link
                                            to=""
                                            className="subscribe-btn"
                                            onClick={props.subscribebtn}
                                        >
                                            Subscribe
                                        </Link>
                                    </div>
                                    <InpersonateButton />
                                </div>
                            </div>

                            {props.dashboardReport.selectedOption.value != 'Select Report' ? (
                                <div className="filter-main-sct">
                                    <div className="filter-collapse">
                                        {/* <div className={props.dashboardReport.open ? 'Collapsible' : 'Collapsible closed'} onClick={props.togglePanel}><span className="Collapsible__trigger">Filter options</span><span className="arrowimage">{arrowdown}</span></div>
                    <div className={props.dashboardReport.open ? 'filteroptions-blk options-blk filter-active' : 'filteroptions-blk options-blk'}> */}
                                        <div
                                            className={
                                                props.dashboardReport.open
                                                    ? 'Collapsible cursor-pointer'
                                                    : 'Collapsible closed'
                                            }
                                        >
                                            <span className="Collapsible__trigger">
                                                Filter options
                                            </span>
                                        </div>
                                        <div
                                            className={
                                                props.dashboardReport.open
                                                    ? 'filteroptions-blk options-blk filter-active'
                                                    : 'filteroptions-blk options-blk'
                                            }
                                        >
                                            <div className="filter-row-blk">
                                                <div className="col-8">
                                                    <div className="filteroptions-row">
                                                        {![
                                                            'credit_lead_return_resason_report',
                                                            'unique_student_report',
                                                        ].includes(
                                                            props.dashboardReport.selectedOption
                                                                .value
                                                        ) ? (
                                                            <div className="col-3">
                                                                <label>Present Date Range</label>
                                                                <Select2
                                                                    onChange={
                                                                        props.presentDatehandleChange
                                                                    }
                                                                    options={daterangeOptions}
                                                                    className="custom-select"
                                                                    label={
                                                                        props.dashboardReport
                                                                            .daterangeoption
                                                                    }
                                                                    defaultValue={
                                                                        props.dashboardReport
                                                                            .daterangeoption
                                                                    }
                                                                    value={
                                                                        props.dashboardReport
                                                                            .daterangeoption
                                                                    }
                                                                    isDisabled={[
                                                                        'interaday_external_partner_lead_detailed_report',
                                                                        'intraday_linkout_lead_detail_report',
                                                                    ].includes(
                                                                        props.dashboardReport
                                                                            .selectedOption.value
                                                                    )}
                                                                />
                                                            </div>
                                                        ) : (
                                                            ''
                                                        )}
                                                        {![
                                                            'credit_lead_return_resason_report',
                                                            'unique_student_report',
                                                            'intraday_linkout_lead_detail_report',
                                                            'interaday_external_partner_lead_detailed_report',
                                                        ].includes(
                                                            props.dashboardReport.selectedOption
                                                                .value
                                                        ) ? (
                                                            <div className="col-3">
                                                                <label>
                                                                    Lead Create Start Date
                                                                </label>
                                                                <div
                                                                    className={
                                                                        props.dashboardReport
                                                                            .daterangeoption
                                                                            .value == 'Custom'
                                                                            ? 'datepicker'
                                                                            : 'datepicker disabled'
                                                                    }
                                                                >
                                                                    <DatePicker
                                                                        name="startDateTime"
                                                                        dateFormat="yyyy/MM/dd"
                                                                        selected={
                                                                            props.dashboardReport
                                                                                .startDate
                                                                        }
                                                                        onChange={date =>
                                                                            props.handleDateChange(
                                                                                'startDateTime',
                                                                                date
                                                                            )
                                                                        }
                                                                    />
                                                                    {props.dashboardReport
                                                                        .error_msg ? (
                                                                        <span className="date-error-msg">
                                                                            Start Date should be
                                                                            less than End Date
                                                                        </span>
                                                                    ) : (
                                                                        ''
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            ''
                                                        )}
                                                    </div>
                                                    <div className="filteroptions-row">
                                                        {props.dashboardReport.selectedOption
                                                            .value !=
                                                            'credit_lead_return_resason_report' &&
                                                        props.dashboardReport.selectedOption
                                                            .value != 'unique_student_report' ? (
                                                            <div className="col-3">
                                                                <label>Medium</label>
                                                                <Select
                                                                    value={
                                                                        props.dashboardReport.medium
                                                                    }
                                                                    onChange={
                                                                        props.mediumhandleChange
                                                                    }
                                                                    className="custom-select"
                                                                    options={
                                                                        props.dashboardReport
                                                                            .medium_
                                                                    }
                                                                    label={
                                                                        props.dashboardReport.medium
                                                                    }
                                                                    isMulti
                                                                    isClearable
                                                                />
                                                            </div>
                                                        ) : (
                                                            ''
                                                        )}
                                                        {![
                                                            'credit_lead_return_resason_report',
                                                            'unique_student_report',
                                                            'intraday_linkout_lead_detail_report',
                                                            'interaday_external_partner_lead_detailed_report',
                                                        ].includes(
                                                            props.dashboardReport.selectedOption
                                                                .value
                                                        ) ? (
                                                            <div className="col-3">
                                                                <label>Lead Create End Date</label>
                                                                <div
                                                                    className={
                                                                        props.dashboardReport
                                                                            .daterangeoption
                                                                            .value == 'Custom'
                                                                            ? 'datepicker'
                                                                            : 'datepicker disabled'
                                                                    }
                                                                >
                                                                    <DatePicker
                                                                        name="EndDateTime"
                                                                        dateFormat="yyyy/MM/dd"
                                                                        selected={
                                                                            props.dashboardReport
                                                                                .endDate
                                                                        }
                                                                        onChange={date =>
                                                                            props.handleDateChange(
                                                                                'EndDateTime',
                                                                                date
                                                                            )
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            ''
                                                        )}
                                                    </div>
                                                    <div className="filteroptions-row">
                                                        {props.dashboardReport.selectedOption
                                                            .value ==
                                                            'external_partner_lead_detailed_report' ||
                                                        props.dashboardReport.selectedOption
                                                            .value ==
                                                            'interaday_external_partner_lead_detailed_report' ? (
                                                            <div
                                                                className={
                                                                    props.dashboardReport
                                                                        .selectedOption.value ==
                                                                        'interaday_external_partner_lead_detailed_report' ||
                                                                    props.dashboardReport
                                                                        .selectedOption.value ==
                                                                        'external_partner_lead_detailed_report'
                                                                        ? 'col-3 clear-both'
                                                                        : 'col-3'
                                                                }
                                                            >
                                                                <label>Offer Type</label>
                                                                <Select2
                                                                    value={
                                                                        props.dashboardReport
                                                                            .offerType
                                                                    }
                                                                    onChange={
                                                                        props.offertypehandleChange
                                                                    }
                                                                    options={
                                                                        props.dashboardReport
                                                                            .offer_Type
                                                                    }
                                                                    className="custom-select"
                                                                    label={
                                                                        props.dashboardReport
                                                                            .offerType
                                                                    }
                                                                    isMulti
                                                                    isClearable
                                                                />
                                                            </div>
                                                        ) : (
                                                            ''
                                                        )}
                                                        <div
                                                            className={
                                                                props.dashboardReport.selectedOption
                                                                    .value ==
                                                                    'external_partner_lead_summary_report' ||
                                                                props.dashboardReport.selectedOption
                                                                    .value ==
                                                                    'real_time_lead_reject_reason'
                                                                    ? 'col-3 clear-both'
                                                                    : 'col-3'
                                                            }
                                                        >
                                                            <label>Source (Provider)</label>
                                                            <Select
                                                                // options={props.dashboardReport.source_Provider}
                                                                // className="custom-select"
                                                                // defaultValue={{ label: props.dashboardReport.source_Provider, value: props.dashboardReport.source_Provider }}
                                                                // isDisabled
                                                                value={
                                                                    props.dashboardReport.sourceList
                                                                }
                                                                onChange={props.sourcehandleChange}
                                                                options={
                                                                    props.dashboardReport
                                                                        .source_List
                                                                }
                                                                className="custom-select"
                                                                label={
                                                                    props.dashboardReport.sourceList
                                                                }
                                                                isMulti
                                                                isClearable
                                                            />
                                                        </div>
                                                        {props.dashboardReport.selectedOption
                                                            .value == 'unique_student_report' ? (
                                                            <div className="col-3">
                                                                <label>Dollar Cost</label>
                                                                <Select
                                                                    value={
                                                                        props.dashboardReport
                                                                            .dollarCost
                                                                    }
                                                                    onChange={
                                                                        props.dollarCosthandleChange
                                                                    }
                                                                    options={
                                                                        props.dashboardReport
                                                                            .dollar_Cost
                                                                    }
                                                                    className="custom-select"
                                                                    label={
                                                                        props.dashboardReport
                                                                            .dollarCost
                                                                    }
                                                                    isMulti
                                                                    isClearable
                                                                />
                                                            </div>
                                                        ) : (
                                                            ''
                                                        )}
                                                        {props.dashboardReport.selectedOption
                                                            .value ==
                                                            'credit_lead_return_resason_report' ||
                                                        props.dashboardReport.selectedOption
                                                            .value == 'unique_student_report' ? (
                                                            <div
                                                                className={
                                                                    props.dashboardReport
                                                                        .selectedOption.value ==
                                                                    'unique_student_report'
                                                                        ? 'col-3 clear-both'
                                                                        : 'col-3'
                                                                }
                                                            >
                                                                <label>Month</label>
                                                                <div className="datepicker">
                                                                    <DatePicker
                                                                        dateFormat="yyyy/MM"
                                                                        showMonthYearPicker
                                                                        selected={
                                                                            props.dashboardReport
                                                                                .selectMonth
                                                                        }
                                                                        name="selectMonth"
                                                                        onChange={date =>
                                                                            props.handleMonthChange(
                                                                                'selectMonth',
                                                                                date
                                                                            )
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            ''
                                                        )}
                                                        <div
                                                            className={
                                                                props.dashboardReport.selectedOption
                                                                    .value ==
                                                                    'external_partner_lead_detailed_report' ||
                                                                props.dashboardReport.selectedOption
                                                                    .value ==
                                                                    'interaday_external_partner_lead_detailed_report' ||
                                                                props.dashboardReport.selectedOption
                                                                    .value ==
                                                                    'credit_lead_return_resason_report'
                                                                    ? 'col-3 clear-both'
                                                                    : 'col-3'
                                                            }
                                                        >
                                                            <label>Vendor</label>
                                                            <Select
                                                                options={
                                                                    props.dashboardReport
                                                                        .source_Provider
                                                                }
                                                                className="custom-select"
                                                                defaultValue={{
                                                                    label: props.dashboardReport
                                                                        .source_Provider,
                                                                    value: props.dashboardReport
                                                                        .source_Provider,
                                                                }}
                                                                isDisabled
                                                            />
                                                        </div>
                                                        {props.dashboardReport.selectedOption
                                                            .value ==
                                                        'credit_lead_return_resason_report' ? (
                                                            <div className="col-3">
                                                                <label>
                                                                    Lead Returned Reason Description
                                                                </label>
                                                                <Select
                                                                    options={
                                                                        props.dashboardReport
                                                                            .lead_Return_Reason_List
                                                                    }
                                                                    value={
                                                                        props.dashboardReport
                                                                            .leadReturnReason
                                                                    }
                                                                    className="custom-select"
                                                                    onChange={reason =>
                                                                        props.leadReturnReasonChange(
                                                                            reason
                                                                        )
                                                                    }
                                                                    label="Lead Returned Reason Description"
                                                                    isMulti
                                                                />
                                                            </div>
                                                        ) : (
                                                            ''
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-4">
                                                    <div className="col-3">
                                                        <button
                                                            className="subscribe-btn"
                                                            id="formElem"
                                                            onClick={props.showReportshandleClick}
                                                        >
                                                            Show Report
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {props.dashboardReport.isReportVisible ? (
                                        <SearchReports searchresults={props.dashboardReport} />
                                    ) : null}
                                </div>
                            ) : (
                                <h4 className="no-rpt-tilte">
                                    No Report selected, Please select report from List
                                </h4>
                            )}
                        </div>
                    </TabPanel>
                </div>
            </main>
        </React.Fragment>
    );
}
